export const USP_TEXT_KEYS = ['workingAtmosphere', 'betterEveryday', 'roomForGrowth'] as const;
